export default "__VITE_ASSET__75ef270f__"